module.exports = __webpack_public_path__ + "fonts/9e12d60.otf";